import { ComponentType } from 'react';
import { RouteConfig, RouteConfigComponentProps } from 'react-router-config';

export const routeBuilder = (
  path: string,
  component: ComponentType<RouteConfigComponentProps<never>> | ComponentType | undefined,
  options?: RouteConfig
): RouteConfig => {
  return {
    path,
    component,
    ...options
  };
};
